import { string, object } from "yup";

const loginSchema = object().shape({
  username: string().required("le nom d'utilisateur est obligatoire"),
  password: string().required("le mot de passe est obligatoire")
});

export default loginSchema;
